<template>
  <div class="sorry">
    <div id="what-we-do" class="what-we-do section">
      <div style="margin: auto;">
        <span style="font-size: 10vh;">:(</span><br><br>
        We are currently down for maintenance. <br><br>
        <div class="small">
          We expect to have all our services running in a couple of hours. Thank you for your patience.
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      }
    }
  },
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sorry {
    min-height: 100vh;
    margin: auto;
  }
  .hello .right {
    background-image: url('./../assets/back-large2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 90%;
    background-color: #fff;    
  }
  .influencer .left {
    background-image: url('./../assets/back2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 70%;
    background-color: #fff; 
  }
  .company .right {
    background-image: url('./../assets/corp.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 70%;
    background-color: #fff;    
  }
  .what-we-do {
    max-width: 900px;
    width: 90%;
    margin: auto;
    min-height: 50vh;
    font-size: 3vh;
  }
  .small {
    font-size: 18px;
  }
  i {
    display: inline;
    border-bottom: 3px dashed #f1f1f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue